module.exports = __webpack_public_path__ + "img/7-SDQ.488430f.jpg";